module.exports = __webpack_public_path__ + "assets/77be75dc0b46c89680dd4439c87fb3e9.svg";